import { Globe } from 'lucide-react';
import { useOpsDomains, useOpsDomainsSummary } from '@/api/operations-resources';
import { OperationsResourceInventoryPage } from './operations-resource-inventory-page';
import { opsDomainColumns, OPS_DOMAIN_TOGGLEABLE_COLUMN_IDS } from './ops-domain-columns';
import { opsDomainFilterFields } from './ops-resource-filter-fields';

/**
 * Cross-org domain inventory for the Tech console — every customer's domains
 * from the unified registry, with dashboard-style summary, filter by
 * customer/provider/status, and drill to the owning org.
 */
export default function OperationsDomainsPage() {
  return (
    <OperationsResourceInventoryPage
      title="Domains"
      description="Cross-org domains — every customer's domains from the registry."
      searchPlaceholder="Search by domain…"
      kindLabel="domains"
      emptyIcon={<Globe size={24} />}
      emptyTitle="No domains found"
      columns={opsDomainColumns}
      toggleableColumnIds={OPS_DOMAIN_TOGGLEABLE_COLUMN_IDS}
      filterFields={opsDomainFilterFields}
      useList={useOpsDomains}
      useSummary={useOpsDomainsSummary}
    />
  );
}
